export default __webpack_public_path__ + "94ad0b15278ae22313299153010d39c5.png";